import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { productListReducer } from './redux/reducers/productReducer'

const reducers = combineReducers({
// 1:reducer
productReducer : productListReducer,

})

const middleware = [thunk]


const store = createStore(reducers, applyMiddleware(...middleware))



export default store